import store from '@/store'
/**
 * @returns {bool}
 */
 export function checkLoginType() {
    var guid = store.getters.guid

    if(guid == -1 || guid == undefined)
    {
        return false
    }
    else
    {
        return true
    }
  }